import { Checkbox } from "@/components/ui/checkbox";
import type { AssetListItem } from '@/services/asset-service';

interface SelectAllCheckboxProps { 
    items: AssetListItem[], 
    selectedUuids: Set<string>, 
    onCheckedChange: (checked: boolean | 'indeterminate') => void 
}

export const SelectAllCheckbox = ({ items, selectedUuids, onCheckedChange }: SelectAllCheckboxProps) => {
    const allOnPageSelected = items.length > 0 && items.every(i => selectedUuids.has(i.uuid));
    const someOnPageSelected = !allOnPageSelected && items.some(i => selectedUuids.has(i.uuid));
    const checkedState = allOnPageSelected ? true : someOnPageSelected ? 'indeterminate' : false;
    return <Checkbox checked={checkedState} onCheckedChange={onCheckedChange} />;
};